"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCKED_SURFACE_TONES = exports.getLockedSurfaceInk = void 0;
const contrast_1 = require("./contrast");
const theme_1 = require("./theme");
// Midpoint of the WCAG luminance scale. Above it a ground needs dark ink, below it
// light - which is what lets one registry hold both the visibility pastels and the
// black media canvas.
const LIGHT_GROUND_THRESHOLD = 0.3;
// A few grounds sit far enough from the rest that the shared ink set does not reach
// AA on them. The mustard fallback bubble is brighter than any visibility pastel, so
// its muted and accent inks have to go deeper than the light theme's.
const INK_OVERRIDES = {
    fallbackMessage: {
        onSurfaceVariant: "#35383e",
        primaryInk: "#0d3f50",
    },
};
const getLockedSurfaceInk = (tone) => {
    const background = theme_1.LOCKED_SURFACES[tone];
    const isLightGround = (0, contrast_1.relativeLuminance)(background) > LIGHT_GROUND_THRESHOLD;
    if (isLightGround) {
        return Object.assign({ background, 
            // Deliberately darker than the light theme's onSurface: the pastels sit high
            // enough in luminance that the extra weight buys real headroom at 12px.
            onSurface: "#1a1a1a", onSurfaceVariant: "#44474e", primaryInk: theme_1.HHNLightTheme.primaryInk, highlight: (0, theme_1.deriveHighlight)(background), base: "light" }, INK_OVERRIDES[tone]);
    }
    return {
        background,
        onSurface: "#e6e1e5",
        onSurfaceVariant: theme_1.HHNDarkTheme.onSurfaceVariant,
        primaryInk: theme_1.HHNDarkTheme.primaryInk,
        // Lightening rather than darkening, because the ground is already near-black.
        highlight: (0, theme_1.deriveHighlight)(background, -0.14),
        base: "dark",
    };
};
exports.getLockedSurfaceInk = getLockedSurfaceInk;
exports.LOCKED_SURFACE_TONES = Object.keys(theme_1.LOCKED_SURFACES);
